import React, { useEffect, useState } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Swal from "sweetalert2";

import {
  subjectAdd,
  subjectList,
  subjectDelete,
  subjectUpdate,
} from "../../../api/Subjects";
import { closeModal, SweetAlertShow, LoadingDiv } from "../../master/Master";
import usePrivateLink from "../../config/usePrivateLink";
import AcademicPortalLayout from "../AcademicPortalLayout";

export default function Subjects() {
  const hasAccess = usePrivateLink();
  const [subjects, setSubjects] = useState([]);
  const [isPractical, setIsPractical] = useState("No");
  const [modalData, setModalData] = useState("");
  const [loading, setLoading] = useState(false);

  const subjectFetch = async () => {
    setLoading(true);
    try {
      const response = await subjectList();
      if (response.data.status) {
        setSubjects(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSubjectCreate = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      const response = await subjectAdd(formData);
      if (response?.data?.status) {
        closeModal("addSubject");
        e.target.reset();
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      subjectFetch();
    }
  };

  const handleDelete = async (id) => {
    setLoading(true);
    try {
      const response = await subjectDelete(id);
      if (response.data.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      subjectFetch();
    }
  };

  const handleSubjectUpdate = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      const response = await subjectUpdate(formData);
      if (response?.data?.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      closeModal("updateSubject");
      subjectFetch();
      setLoading(false);
    }
  };

  useEffect(() => {
    subjectFetch();
  }, []);

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <AcademicPortalLayout />
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="row g-2">
                          <div className="col-sm-6">
                            <h4 className="text-primary m-0">Subjects</h4>
                          </div>
                          <div className="col-sm-6 text-end">
                            {hasAccess("/subject/add") && (
                              <button
                                className="btn btn-outline-primary btn-sm"
                                data-bs-toggle="modal"
                                data-bs-target="#addSubject"
                              >
                                <i className="ri-add-circle-line me-2"></i>
                                Add Subject
                              </button>
                            )}
                          </div>
                          <div className="col-12">
                            <div className="table-responsive">
                              <table className="table table-hover">
                                <thead>
                                  <tr>
                                    <th>#</th>
                                    <th>Subject Name</th>
                                    <th>Subject Code</th>
                                    <th>Is Practical</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {subjects.map((item, index) => (
                                    <tr key={item.id}>
                                      <td>{index + 1 || "N/A"}</td>
                                      <td className="text-primary fw-semibold">
                                        {item.name || "N/A"}
                                      </td>
                                      <td>{item.subject_code || "N/A"}</td>
                                      <td>
                                        <span
                                          className={`btn btn-sm px-2 py-1 rounded-3 ${
                                            item.is_practical === "Yes"
                                              ? "btn-label-primary"
                                              : "btn-label-info"
                                          }`}
                                        >
                                          {item.is_practical}
                                        </span>
                                      </td>
                                      <td className="d-flex gap-1">
                                        {hasAccess("/subject/update") && (
                                          <button
                                            type="button"
                                            className="btn btn-outline-info btn-sm"
                                            data-bs-toggle="modal"
                                            data-bs-target="#updateSubject"
                                            onClick={() => setModalData(item)}
                                          >
                                            <i className="ri-ball-pen-line"></i>
                                          </button>
                                        )}
                                        {hasAccess("/subject/delete") && (
                                          <button
                                            className="btn btn-outline-danger btn-sm"
                                            onClick={() => {
                                              Swal.fire({
                                                title: "Are you sure?",
                                                text: "This action will permanently delete!",
                                                icon: "warning",
                                                showCancelButton: true,
                                                confirmButtonColor: "#d33",
                                                cancelButtonColor: "#6c757d",
                                                confirmButtonText:
                                                  "Yes, delete it!",
                                                cancelButtonText: "Cancel",
                                              }).then(async (result) => {
                                                if (result.isConfirmed) {
                                                  handleDelete(item.id);
                                                }
                                              });
                                            }}
                                          >
                                            <i className="ri-delete-bin-line"></i>
                                          </button>
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="addSubject"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={handleSubjectCreate}>
              <div className="modal-header bg-label-primary py-3">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Add Subject
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className="form-control input-capitalize"
                    id="subjectTitle"
                    placeholder="Enter Subject Title"
                    name="title"
                    required
                  />
                  <label htmlFor="subjectTitle">Subject Title</label>
                </div>
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className="form-control"
                    id="subjectCode"
                    placeholder="Enter Subject Code"
                    name="sub_code"
                    required
                  />
                  <label htmlFor="subjectCode">Subject Code</label>
                </div>
                <div className="mb-3">
                  <label className="form-label fw-semibold d-block">
                    Is Practical? {isPractical === "Yes" ? "Yes" : "No"}
                  </label>

                  <input
                    type="hidden"
                    name="is_practical"
                    value={isPractical}
                  />
                  <label className="switch switch-square switch-md">
                    <input
                      type="checkbox"
                      className="switch-input"
                      checked={isPractical === "Yes"}
                      onChange={(e) =>
                        setIsPractical(e.target.checked ? "Yes" : "No")
                      }
                    />
                    <span className="switch-toggle-slider">
                      <span className="switch-on">
                        <i className="icon-base ri ri-check-line"></i>
                      </span>
                    </span>
                    <span className="switch-label">Practical</span>
                  </label>
                </div>
              </div>
              <div className="modal-footer  bg-label-primary py-3">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading} // Disable the button while loading
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Submit"
                  )}
                  {loading ? " Submitting..." : ""}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="updateSubject"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form className="" onSubmit={handleSubjectUpdate}>
              <div className="modal-header bg-label-primary py-3">
                <div>
                  <h1 className="modal-title fs-5" id="exampleModalLabel">
                    Subject Update
                  </h1>
                </div>
                <div className="ms-auto">
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
              </div>
              <div className="modal-body">
                <div className="form-floating form-floating-outline mb-6">
                  <input
                    type="hidden"
                    className="form-control"
                    value={modalData?.id}
                    name="id"
                  />
                  <input
                    type="text"
                    className="form-control input-capitalize"
                    id="subjectTitle"
                    placeholder="Enter Subject Title"
                    defaultValue={modalData?.name}
                    name="name"
                    required
                  />
                  <label htmlFor="subjectTitle">Subject Title</label>
                </div>

                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className="form-control"
                    id="subjectCode"
                    placeholder="Enter Subject Code"
                    defaultValue={modalData?.subject_code}
                    name="subject_code"
                    required
                  />
                  <label htmlFor="subjectCode">Subject Code</label>
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold d-block mb-2">
                    Is Practical? {modalData?.is_practical}
                  </label>
                  <label className="switch switch-square switch-md">
                    <input
                      type="hidden"
                      name="is_practical"
                      value={modalData?.is_practical}
                    />
                    <input
                      type="checkbox"
                      className="switch-input"
                      checked={modalData?.is_practical === "Yes"}
                      onChange={(e) =>
                        setModalData({
                          ...modalData,
                          is_practical: e.target.checked ? "Yes" : "No",
                        })
                      }
                    />
                    <span className="switch-toggle-slider">
                      <span className="switch-on">
                        <i className="icon-base ri ri-check-line"></i>
                      </span>
                      {/* <span className="switch-off">
                        <i className="icon-base ri ri-close-line"></i>
                      </span> */}
                    </span>
                    <span className="switch-label">Practical</span>
                  </label>
                </div>
              </div>

              <div className="modal-footer bg-label-primary py-3">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Submit"
                  )}
                  {loading ? " Submitting..." : ""}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
